import { atom } from "recoil";

export const userActionLogStore = atom({
	key: "userActionLogStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentSearch: undefined,
		currentSearchType: { value: "action" },
		currentOption: {
			action: { label: "currencyChange", value: "currencyChange" },
		},
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
